/* Section 1, the hero (home study v95 + arrival v102). Source: theme-build/home/assets/rhm-hero.js
   The open-water film is drawn through a WebGL shader that grades it to deep Rippl navy and lays low ripples under
   the pointer (shader in assets/rippl-water.js, shared with the footer); the arrival plays once a visit, from first paint (see the
   section's inline scripts). The framed pair (25 Oct 2026) is plain markup and CSS: nothing here moves it. */
(function () {
  'use strict';
  var W = window, D = document;
  function init(sec) {
    if (!sec || sec.__rhm) return; sec.__rhm = 1;
    var stage = sec.querySelector('.rhm-stage'), cv = stage.querySelector('canvas'), seaV = stage.querySelector('.rhm-seav'), still = stage.querySelector('.rhm-still');
    var reduce = W.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dpr = 1, Wd = 0, Hd = 0, t0 = performance.now();
    var editor = W.Shopify && W.Shopify.designMode;

    /* ---- arrival: started at first paint by the section's inline scripts (once a visit, never with reduced motion or
       in the theme editor); here it is kept on course. The mark's path is measured from its resting place, never from
       where an animation has it, so a re-measure (load, fonts, resize) can't move the landing; a scroll during the
       glide is added to the path so it still lands on the header logo, which stays put at the top (13 Oct 2026). ---- */
    var root = D.documentElement, im = sec.querySelector('.rhm-intro img'), s0 = im && im.__rhmS0 || 0;
    var arrive = stage.classList.contains('rhm-entering');
    var tA = arrive && W.__rhmArrT || performance.now();
    root.classList.remove('rhm-arrhold');
    function markVars() {
      var lg = D.querySelector('.rh-logo .rh-mark') || D.querySelector('.rh-logo');
      if (!im || !lg) return;
      var a = im.getBoundingClientRect(), b = lg.getBoundingClientRect(); if (!a.height || !b.height) return;
      var cs = getComputedStyle(im), cx = a.left + a.width / 2, cy = a.top + a.height / 2, k = 1, m;
      if (cs.translate && cs.translate !== 'none') { m = cs.translate.split(' '); cx -= parseFloat(m[0]) || 0; cy -= parseFloat(m[1]) || 0; }
      if (cs.transform && cs.transform !== 'none' && W.DOMMatrixReadOnly) { m = new DOMMatrixReadOnly(cs.transform); cx -= m.e; cy -= m.f; k = m.a || 1; }
      s0 = W.scrollY;
      im.style.setProperty('--mx', ((b.left + b.width / 2) - cx).toFixed(1) + 'px');
      im.style.setProperty('--my', ((b.top + b.height / 2) - cy).toFixed(1) + 'px');
      im.style.setProperty('--ms', (b.height / (a.height / k)).toFixed(4));
      im.style.setProperty('--sy', '0px');
    }
    function arriving() { return stage.classList.contains('rhm-entering'); }
    function finish() { stage.classList.remove('rhm-entering'); root.classList.remove('rhm-arr'); W.removeEventListener('scroll', follow); }
    function follow() {
      if (!arriving() || !im) return;
      if (W.scrollY > stage.offsetHeight * .5) { finish(); return; }   /* the hero is mostly gone: show the page as it ends */
      im.style.setProperty('--sy', (W.scrollY - s0).toFixed(1) + 'px');
    }
    function again() { if (arriving()) markVars(); }
    if (arrive) {
      if (reduce || editor) finish();
      else {
        markVars(); follow();
        W.addEventListener('scroll', follow, { passive: true });
        W.addEventListener('load', again);
        W.addEventListener('resize', again);
        if (D.fonts && D.fonts.ready) D.fonts.ready.then(again);
        setTimeout(finish, Math.max(0, 3600 - (performance.now() - tA)));
        sec.querySelector('.rhm-intro').addEventListener('click', finish);
      }
      arrive = arriving();
    }
    var wait = arrive ? 800 : 0;

    /* ---- the water ---- */
    var comp = D.createElement('canvas'), cx = comp.getContext('2d'), sea = new Image(), gl = null, U = {}, tex, drops = new Float32Array(64), di = 0, started = false, dirty = true, lastDrop = -1e9;
    /* the film goes up to the GPU only when it has a new frame (about 20 a second at .8 speed, not 60), and the water
       is drawn only when the film, a ripple or the size has changed (Apple audit round 2, C3) */
    var fresh = (W.RipplWater && W.RipplWater.watch && seaV) ? W.RipplWater.watch(seaV) : { fresh: function () { return true; }, poke: function () {} };
    sea.crossOrigin = 'anonymous';
    function now() { return (performance.now() - t0) / 1000; }
    function drop(x, y, s) { drops.set([x, y, now(), s], di * 4); di = (di + 1) % 16; lastDrop = performance.now(); }
    function cover(img, w, h) { var s = Math.max(w / img.naturalWidth, h / img.naturalHeight), iw = img.naturalWidth * s, ih = img.naturalHeight * s; cx.drawImage(img, (w - iw) / 2, (h - ih) / 2, iw, ih); }
    function compose() { comp.width = Math.round(Wd * dpr); comp.height = Math.round(Hd * dpr); cx.setTransform(dpr, 0, 0, dpr, 0, 0); cx.fillStyle = '#16233A'; cx.fillRect(0, 0, Wd, Hd); if (sea.naturalWidth) cover(sea, Wd, Hd); }
    /* the shader is shared with the site footer (assets/rippl-water.js); its extra uniforms stay neutral here */
    function setup() {
      var w = W.RipplWater && W.RipplWater.create(cv);
      if (!w) { gl = null; return false; }
      gl = w.gl; U = w.U; tex = w.tex;
      cv.addEventListener('webglcontextlost', function (e) { e.preventDefault(); gl = null; flat(); });
      return true;
    }
    /* the approved grade: low ripples (gain .6 x .06), rings 112 apart, edge 16, the film set well back (base .53, highlights .21) */
    function refresh() {
      var r = stage.getBoundingClientRect(); Wd = r.width; Hd = r.height; if (!Wd || !Hd) return;
      /* at most 2x and at most about 3.2 million pixels (never under 1x): the film is 1600 wide, so more is upscaling */
      dpr = Math.min(W.devicePixelRatio || 1, 2, Math.max(1, Math.sqrt(3.2e6 / (Wd * Hd))));
      compose();
      cv.width = comp.width; cv.height = comp.height;
      if (!gl) return;
      gl.viewport(0, 0, cv.width, cv.height); gl.uniform2f(U.R, cv.width, cv.height);
      gl.uniform1f(U.G, .036); gl.uniform1f(U.F, 112); gl.uniform1f(U.K, 16); gl.uniform1f(U.BS, .53); gl.uniform1f(U.HS, .21);
      gl.bindTexture(gl.TEXTURE_2D, tex); gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, comp);
      dirty = true; fresh.poke();
    }
    var visible = true, raf = 0;
    function loop() {
      raf = 0; if (!gl || !visible) return;
      var nf = false;
      if (seaV && seaV.readyState >= 2 && !seaV.paused && fresh.fresh()) { nf = true; gl.bindTexture(gl.TEXTURE_2D, tex); try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, seaV); } catch (e) {} }
      if (nf || dirty || performance.now() - lastDrop < 2700) { dirty = false; gl.uniform1f(U.t, now()); gl.uniform4fv(U.D, drops); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4); }
      raf = requestAnimationFrame(loop);
    }
    function reveal() { setTimeout(function () { stage.classList.add('rhm-wready'); setTimeout(function () { stage.classList.add('rhm-wdone'); }, 3700); }, Math.max(0, wait - (performance.now() - tA))); }
    function start() {
      if (started) return; started = true;
      if (reduce || !setup()) { gl = null; flat(); }
      refresh(); reveal();
      if (gl) { raf = requestAnimationFrame(loop); if (!reduce) setInterval(function () { if (visible && !D.hidden) drop(.2 + Math.random() * .6, .2 + Math.random() * .45, .5); }, 3400); }
    }
    function flat() { stage.classList.add('rhm-flat'); if (still && !still.getAttribute('src')) still.src = still.dataset.src; }
    sea.onload = function () { if (started) refresh(); else start(); };
    sea.onerror = start;
    sea.src = stage.dataset.still;
    if ('ResizeObserver' in W) new ResizeObserver(function () { if (started) refresh(); }).observe(stage);
    if ('IntersectionObserver' in W) new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; if (visible) { if (!raf && gl) raf = requestAnimationFrame(loop); if (seaV.paused && seaV.getAttribute('src')) play(); } else if (!seaV.paused) seaV.pause(); }); }).observe(stage);

    /* the film: wide cut on desktop, portrait on a phone, slowed to .8 */
    function play() { if (reduce) return; seaV.playbackRate = .8; var p = seaV.play(); if (p && p.catch) p.catch(function () {}); }
    function media() { if (reduce) return; var want = seaV.dataset[W.innerWidth >= 820 ? 'w' : 'p']; if (want && seaV.getAttribute('src') !== want) { seaV.src = want; fresh.poke(); } play(); }
    function wake() { if (seaV.paused && visible) media(); }
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (e) { D.addEventListener(e, wake, { passive: true }); });
    W.addEventListener('scroll', wake, { passive: true }); seaV.addEventListener('canplay', wake);
    D.addEventListener('visibilitychange', function () { if (!D.hidden) wake(); });
    setTimeout(media, 300);
    var rt = 0; W.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(media, 200); });

    /* ---- pointer ripples, low, and only while the hero is the thing on screen ---- */
    var lastMove = 0;
    function pos(e) { var r = stage.getBoundingClientRect(); return [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height]; }
    stage.addEventListener('pointermove', function (e) { if (W.scrollY > stage.offsetHeight * .25) return; var t = performance.now(); if (t - lastMove < 110) return; lastMove = t; var p = pos(e); drop(p[0], p[1], .3); });
    stage.addEventListener('pointerdown', function (e) {
      var p = pos(e); drop(p[0], p[1], 1);
      if (e.pointerType !== 'mouse' || (e.target.closest && e.target.closest('a,button'))) return;
      var r = stage.getBoundingClientRect(), s = D.createElement('span'); s.className = 'rhm-pulse'; s.style.left = (e.clientX - r.left) + 'px'; s.style.top = (e.clientY - r.top) + 'px'; stage.appendChild(s); setTimeout(function () { s.remove(); }, 1200);
    });


    /* ---- the framed pair (25 Oct 2026): on a phone the Custom branded frame lands on the three doors themselves, not the
       section heading above them, so the choice is on screen straight after the tap (Bade, 26 Oct 2026). On wider screens
       the plain #custom-branded jump already shows the heading and all three doors, so it is left to the browser. ---- */
    sec.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.rhm-fp-a');
      if (!a || W.innerWidth >= 750 || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var h = a.getAttribute('href') || '';
      if (h.charAt(0) !== '#' || h.length < 2) return;
      var tgt; try { tgt = D.querySelector(h); } catch (er) { return; }
      /* the section holds more than one set of doors (one waits hidden for another state): take the one that is showing */
      var doors = tgt && [].slice.call(tgt.querySelectorAll('.rhm-drs')).filter(function (d) { return d.getBoundingClientRect().height > 0; })[0];
      if (!doors) return;
      e.preventDefault();
      if (W.rhmCustomLoad) { try { W.rhmCustomLoad(); } catch (er) {} }
      function top() {
        var bar = 0;
        [].slice.call(D.querySelectorAll('.rh')).forEach(function (el) { var r = el.getBoundingClientRect(), p = getComputedStyle(el).position; if ((p === 'fixed' || p === 'sticky') && r.top <= 0 && r.bottom > bar && r.bottom < 200) bar = r.bottom; });
        return Math.max(0, W.scrollY + doors.getBoundingClientRect().top - (bar || 64) - 16);
      }
      var smooth = !reduce;
      W.scrollTo({ top: top(), behavior: smooth ? 'smooth' : 'auto' });
      /* the section's own script may still be laying out the lineup above: settle once more on the doors */
      setTimeout(function () { var y = top(); if (Math.abs(y - W.scrollY) > 4) W.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' }); }, smooth ? 900 : 300);
    });
  }
  function boot() { [].slice.call(D.querySelectorAll('.rhm-hero')).forEach(init); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', boot);
})();
